import { render, staticRenderFns } from "./OrderListDeliveryNew.vue?vue&type=template&id=b22c2f58&scoped=true"
import script from "./OrderListDeliveryNew.vue?vue&type=script&lang=js"
export * from "./OrderListDeliveryNew.vue?vue&type=script&lang=js"
import style0 from "./OrderListDeliveryNew.vue?vue&type=style&index=0&id=b22c2f58&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22c2f58",
  null
  
)

export default component.exports